/**
 * Topic instances use `notes` as a priority signal (prototype convention):
 *   'S' (strategic) → 'R' (recommended) → 'O' (opportunistic) → 'S' …
 *
 * Empty notes is treated as opportunistic and cycles into 'S' on first click.
 */

import type { PriorityTier } from '../../../utils/priority';

export type TopicNotesPriority = 'S' | 'R' | 'O' | '';

export function notesToTier(notes: string | undefined | null): PriorityTier {
  switch (notes) {
    case 'S':
      return 'strategic';
    case 'R':
      return 'recommended';
    default:
      return 'opportunistic';
  }
}

export function nextNotes(current: string | undefined | null): TopicNotesPriority {
  switch (current) {
    case 'S':
      return 'R';
    case 'R':
      return 'O';
    case 'O':
      return 'S';
    default:
      return 'S';
  }
}
